<script>
  import { Modal } from "svelte-utilities";
  import { navigate } from "svelte-routing";
  import { onMount } from "svelte";

  import NewSourceDocument from "./NewSourceDocument.svelte";
  import NewWorkingDocument from "./NewWorkingDocument.svelte";
  import nameMinusExtension from "@local/extensions/utilities/name-minus-extension.js";

  import eb from "#src/extensions/event-bus.js";

  /**
   * @typedef {"imported" | "virtual" | "remote" | null} DocumentType
   */

  function createDoc(groupId, index) {
    return {
      id: crypto.randomUUID(),
      group_id: groupId,
      index,
      name: "Untitled",
      ready: true,
      data: {
        pages: null,
        thumbnail: {},
      },
      is_virtual: true,
      /** @type {DocumentType} */
      type: "virtual",
      source_document_id: null,
    };
  }

  export let documents;
  export let group;

  let modal;
  let newDoc = createDoc();
  let stage = "uploading"; // "uploading" | "processing" | "selecting-pages"

  function openModal() {
    stage = "importing";
    modal.open();
  }

  async function selectPages(id) {
    const exists = $group.documents[id];
    if (!exists) {
      return close();
    }
    newDoc = createDoc($group.id, documents.length);
    newDoc.name = nameMinusExtension(exists.name);
    newDoc.source_document_id = id;
    newDoc.data.thumbnail = exists.data.thumbnail;
    group.addDocument(newDoc);
    stage = "selecting-pages";
  }

  function close() {
    if (modal) {
      modal.close();
    }
  }

  function gotoDoc(id) {
    modal.close();
    if ($group.documents[id]) {
      navigate(`/jobs/${$group.job_id}/documents/${id}`);
    }
  }

  onMount(() => {
    eb.on("open-create-document-modal", openModal);

    return () => {
      eb.unsubscribe("open-create-document-modal", openModal);
    };
  });
</script>

<Modal bind:this={modal} closeable width="36rem">
  <div slot="title">Create New Document</div>
  <div slot="content" class="flex flex-col gap-4 overflow-hidden">
    {#if stage === "importing"}
      <NewSourceDocument {group} {documents} on:done-uploading={(e) => selectPages(e.detail.id)} />
    {:else if stage === "selecting-pages"}
      <NewWorkingDocument
        {group}
        {documents}
        {newDoc}
        on:done-uploading={(e) => gotoDoc(e.detail.id)}
        action="update" />
    {/if}
  </div>
</Modal>

<style lang="scss">
  .doc-button-grid {
    @apply flex gap-4;

    button {
      @apply border bg-gray-200 border-gray-300 basis-1/2 p-4 flex flex-col justify-between gap-4;

      &:hover {
        @apply border-gray-500;
      }
    }

    button .description {
      @apply flex flex-col justify-center h-8;
    }
  }
</style>
